import {ReactNode} from 'react'
import cn from 'clsx'
import {Button} from 'antd'

import './ButtonLink.scss'

interface ButtonLinkProps {
  className?: string
  children: ReactNode
  icon?: ReactNode
  danger?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
}

export default function ButtonLink({
  className,
  children,
  icon,
  danger,
  ...props
}: ButtonLinkProps) {
  return (
    <Button
      className={cn(className, 'ButtonLink', danger && 'ButtonLink_danger')}
      type="link"
      {...props}
    >
      {children}
      {icon}
    </Button>
  )
}
